import type {TranslationKey} from "./ua";

const en: Record<TranslationKey, string> = {
    "common.loading": "Waiting for response...",

    "nav.login": "Log in",
    "nav.profile": "Profile",
    "nav.logout": "Log out",
    "nav.stats": "Statistics",
    "nav.topPlayers": "Top players",
    "nav.leaders": "Leaders",
    "nav.shop": "Shop",
    "nav.case": "Crate",
    "nav.giveaways": "Giveaways",

    "header.donateInfo": "Donate 1000 UAH or more and get +10% to your top-up. These are voluntary donations for the project's development and are non-refundable.",
    "header.bonus": "Your personal bonus +{n}% 👍",
    "header.noBonus": "You don't have a personal bonus yet 😕",

    "servers.title": "Choose server type",
    "servers.text": "This affects which items are available for purchase, <b>trio</b> does not have all items.",

    "footer.agreement": "User agreement",
    "footer.privacy": "Privacy policy",
    "footer.about": "About us",
    "footer.nav": "Sections",
    "footer.info": "Information",
    "footer.tagline": "ASKOLD servers: item shop, lucky crate and weekly giveaways.",

    "product.buy": "Buy",
    "product.loginSteam": "Log in with Steam",
    "product.friendPlaceholder": "Friend's SteamId",
    "product.noServer": "You haven't selected a server!",
    "product.noFriend": "You haven't entered your friend's steamId!",
    "product.badSteamId": "Invalid SteamID: it must be exactly 17 digits!",
    "product.error": "Something went wrong",
    "product.confirmBefore": "Are you sure you want to buy",
    "product.confirmOnServer": "on server",
    "product.pickup": "After purchase, pick it up with the <b>\"u\"</b> key",
    "product.yes": "Yes",
    "product.cancel": "Cancel",
    "product.color": "Color",

    "stats.title": "Top players",
    "stats.subtitle": "The best players on our servers by kills, K/D and shot distance",
    "stats.kills": "Kills",
    "stats.killsLabel": "kills",
    "stats.kd": "K/D",
    "stats.distance": "Distance",
    "stats.distanceLabel": "longest shot",
    "stats.playtime": "Playtime",
    "stats.playtimeLabel": "played",
    "stats.deaths": "Deaths",
    "stats.farthest": "Farthest",
    "stats.time": "Time",
    "stats.player": "Player",
    "stats.error": "Statistics are temporarily unavailable. Please try again later.",
    "stats.empty": "No data yet.",
    "stats.hours": "h",
    "stats.minutes": "min",
    "stats.meters": "m",

    "case.title": "Lucky crate",
    "banner.cta": "Open crate",
    "banner.shortPrice": "For {price} ₴",
    "banner.shortMax": "win items up to {max} ₴",
    "banner.gwCta": "Join",
    "banner.gwEnds": "Ends in",
    "case.subtitle": "Open the crate and get a random item from the shop. Your prize goes straight to your basket.",
    "case.server": "Delivery server",
    "case.open": "Open for {price} ₴",
    "case.opening": "Opening...",
    "case.login": "Log in with Steam to open the crate",
    "case.noMoney": "Not enough balance",
    "case.deposit": "Top up balance",
    "case.contents": "Crate contents",
    "case.items": "{n} items",
    "case.chance": "Chance",
    "case.empty": "The crate is empty for this server yet.",
    "case.error": "Could not load the crate. Please try again later.",
    "case.disabled": "The lucky crate is unavailable right now. Check back later!",
    "case.openError": "Could not open the crate",
    "case.youWon": "You got",
    "case.inBasket": "The item is already in your basket on {server}. Pick it up in game with the \"U\" key.",
    "case.toBasket": "Go to basket",
    "case.again": "Open again",
    "case.return": "Return for {price} ₴",
    "case.returnHint": "Items from the crate are returned for 50% of the price",
    "case.returnError": "Could not return the item",
    "case.noRefund": "Crate items can be returned for 50% of their price (except priority and sets). The more expensive the item, the lower the chance.",
    "case.skip": "Skip",
    "case.rarity.legendary": "Legendary",
    "case.rarity.epic": "Epic",
    "case.rarity.rare": "Rare",
    "case.rarity.uncommon": "Uncommon",
    "case.rarity.common": "Common",

    "giveaways.title": "Giveaways",
    "giveaways.subtitle": "Every week we give away random shop items. The winner is picked at random by the server, and the prize goes straight to their basket.",
    "giveaways.drawIn": "Draw in",
    "giveaways.drawAt": "Every Saturday at 21:00",
    "giveaways.drawing": "Drawing the winners...",
    "giveaways.days": "d",
    "giveaways.seconds": "s",
    "giveaways.type.all": "For everyone",
    "giveaways.type.priority": "For priority owners",
    "giveaways.type.set": "For set owners",
    "giveaways.rule.all": "Free for every player — just press \"Join\"",
    "giveaways.rule.priority": "Players with an active priority can join",
    "giveaways.rule.set": "Players with an active set can join",
    "giveaways.worth": "worth {price} ₴",
    "giveaways.participants": "Participants: {n}",
    "giveaways.beFirst": "Be the first to join",
    "giveaways.server": "Prize server",
    "giveaways.join": "Join",
    "giveaways.checking": "Joining...",
    "giveaways.joined": "You're in · {server}",
    "giveaways.joinedToast": "You've joined the giveaway! Good luck 🍀",
    "giveaways.login": "Log in with Steam",
    "giveaways.needPriority": "Requires an active priority",
    "giveaways.needSet": "Requires an active set",
    "giveaways.toShop": "Go to shop",
    "giveaways.error": "Could not load giveaways. Please try again later.",
    "giveaways.joinError": "Could not join",
    "giveaways.empty": "Giveaways are coming soon.",
    "giveaways.winners": "Recent winners",
    "giveaways.noWinners": "No winners yet — be the first!",
    "giveaways.of": "of {n}",
};

export default en;
